import "./App.css";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import { CoachView } from "./views/coach";
import "canvas-core-react/lib/CanvasStyles.css";
import { CoachProvider } from "./context";
import setConfig from "cldffecop-tagging-utils";
setConfig({
  name: "coach-financiero",
  brand: "scotiabank",
  variant: "publico",
  category: "coach-financiero",
});

function App() {
  return (
    <CoachProvider>
      <Router>
        <Switch>
          <Route>
            <CoachView />
          </Route>
        </Switch>
      </Router>
    </CoachProvider>
  );
}

export default App;
